// extracted by mini-css-extract-plugin
export default {"wrapper":"Logo_wrapper__aH5ni","logo":"Logo_logo__6yrBi"};